import axios from 'axios'
import { LISTAR_FILTROS_AGENCIA } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosAgencia (idEmpresa) {
  const url = `${URL}/agencia/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
          type: LISTAR_FILTROS_AGENCIA,
        payload: response

      })
  );
}
